import React from "react";

import { withTranslation, WithTranslation } from "react-i18next";
import AuthService from "../../../../../common/AuthService";
import { IMessageBoxParams } from "../../../../../common/MessageBox";
import { IConfirmDialogParams } from "../../../../../common/ConfirmDialog";
import { IProjectRow } from "../../../../../webapi/service/getProjects";
import { IFileRow } from "../../../../../webapi/service/getFIles";
import "./simsettings.css"
import "../../../../main.css";
import SimSettingsFormContents from "./SimSettingsFormContents"

export interface IProps extends WithTranslation {
  /**
   * 認証サービス
   */
  authService?: AuthService;
  /**
   * 選択されたプロジェクト情報
   */
  projectInfo: IProjectRow;
  /**
   * ファイル情報一覧
   */
  rows: IFileRow[];
  /**
   * 戻るボタンが押された場合に呼び出されます
   */
  onBack: () => void;
  /**
   * プロジェクト一覧画面に戻る場合に呼び出します
   */
  onTop: () => void;
  /**
   * ローディング画面の表示非表示を切り替えます
   * @param loading - ローディング画面を表示する場合はtrue
   */
  onLoading: (loading: boolean) => void;
  /**
   * メッセージBoxを表示します
   * @param params - メッセージBoxパラメータ
   */
  showMessage: (params: IMessageBoxParams) => void;
  /**
   * 確認ダイアログを表示します。
   * @param params - 確認ダイアログパラメータ
   */
  showConfirm: (param: IConfirmDialogParams) => void;
  /**
   * 通信エラーが発生した場合に呼び出します
   * @param id - メッセージID
   * @param status - httpステータスコード
   */
  onCommunicationError: (
    id: string | undefined,
    status: number | undefined
  ) => void;
  /**
   * 非操作タイムアウトをリセットする場合に呼び出します
   */
  resetUnoperatedTimeout: () => void;
}

class SimSettingsForm extends React.Component<IProps> {
  
  constructor(props: IProps) {
    super(props);
  }

  getContents(): JSX.Element {
    let contents = <div />;
    contents = (
      <SimSettingsFormContents
        authService={this.props.authService}
        projectInfo={this.props.projectInfo}
        onLoading={this.props.onLoading}        
        onBack={this.props.onBack}
        onTop={this.props.onTop}
        showMessage={this.props.showMessage}
        onCommunicationError={this.props.onCommunicationError}
        resetUnoperatedTimeout={this.props.resetUnoperatedTimeout}
      />) 
    
    return contents;
  }

  render(): JSX.Element {
    const contents = this.getContents()

    return contents;
  }

}

export default withTranslation()(SimSettingsForm);


